module.exports = __webpack_public_path__ + "static/img/oval.be00fc4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/gif/oval.svg
// module id = 238
// module chunks = 18